import { useQueryClient } from "react-query";
import { axiosInstance } from "api/axios";
import useCustomMutation from "hooks/useCustomMutation";
import useCustomQuery from "hooks/useCustomQuery";
import { ICruSettings } from "dto/Contracts/IContractCru";

/**
 * Integracja z Centralnym Rejestrem Umów (MF) — ustawienia firmy (BE: CruController).
 * Klucz API jest tylko zapisywalny (nigdy nie wraca z BE); ważny 6 miesięcy − 1 dzień.
 */

const QUERY_KEY = "cru.settings";

const getSettingsApi = async (): Promise<ICruSettings> =>
  (await axiosInstance.get<ICruSettings>("/cru/settings")).data;

const setApiKeyApi = async (payload: {
  ApiKey: string;
  InstitutionRegon?: string | null;
}): Promise<ICruSettings> =>
  (await axiosInstance.post<ICruSettings>("/cru/settings/apiKey", payload)).data;

const removeApiKeyApi = async (): Promise<ICruSettings> =>
  (await axiosInstance.delete<ICruSettings>("/cru/settings/apiKey")).data;

const cruService = {
  useGetSettings: (enabled = true) =>
    useCustomQuery<ICruSettings>([QUERY_KEY], getSettingsApi, {
      enabled,
      retry: false,
    }),

  useSetApiKey: () => {
    const queryClient = useQueryClient();
    return useCustomMutation<
      ICruSettings,
      { ApiKey: string; InstitutionRegon?: string | null }
    >(setApiKeyApi, {
      onSuccess: (data) => {
        queryClient.setQueryData([QUERY_KEY], data);
      },
    });
  },

  useRemoveApiKey: () => {
    const queryClient = useQueryClient();
    return useCustomMutation<ICruSettings, void>(removeApiKeyApi, {
      onSuccess: (data) => {
        queryClient.setQueryData([QUERY_KEY], data);
      },
    });
  },
};

export default cruService;
